import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('waterfalls-h', true, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: props.strokeLinejoin
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 6.000000)",
    fill: props.colors[1],
    fillRule: "nonzero",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "14",
    height: "11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "25",
    width: "14",
    height: "11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "0",
    width: "14",
    height: "17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "19",
    width: "14",
    height: "17"
  }))));
});